import { defaultTo } from '../utils/bits'
import { signUserFunction } from './gallery-properties.flow'

export default function CalcModalsUse(isIframeMode) {
  return signUserFunction(calcModalsUse)
  function calcModalsUse(rawVal, calcProp) {
    const modals_use = defaultTo(rawVal, true)
    const carousel_mode = calcProp('carousel_mode')
    return modals_use && (!carousel_mode || !isIframeMode)
  }
}
